/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Codebase_TitleInputs */

const en_landing_card_codebase_title = /** @type {(inputs: Landing_Card_Codebase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a codebase`)
};

const id_landing_card_codebase_title = /** @type {(inputs: Landing_Card_Codebase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sambungkan codebase`)
};

/**
* | output |
* | --- |
* | "Connect a codebase" |
*
* @param {Landing_Card_Codebase_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_codebase_title = /** @type {((inputs?: Landing_Card_Codebase_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Codebase_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_codebase_title(inputs)
	return en_landing_card_codebase_title(inputs)
});